import { selectIsExportUrlFiltersCAFeatureFlagOn } from 'core/userContext';
import momentTz from 'moment-timezone';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { CUSTOM_RANGE } from 'ui/datePicker/helpers';
import { getUrlParams } from 'utils/urlParams';
import { defaultTimezone } from '../constants';
import { useQueryFilterParamsCA } from '../hooks';
import { selectMessageMedium } from '../selectors';
import { UrlParamsContext } from './UrlParamsContext';

export const UrlParamsContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { search } = useLocation();
  const { campaignId } = getUrlParams(search);
  const exportUrlCAFFOn = useSelector(selectIsExportUrlFiltersCAFeatureFlagOn);
  const medium = useSelector(selectMessageMedium);
  const validatedQueryParams = useQueryFilterParamsCA([medium]);

  const {
    startTime,
    endTime,
    timezone,
    timePreset,
    overviewMetrics,
    timeSeriesMetrics,
    segmentMetrics,
    segment,
    region,
    variantId,
  } = validatedQueryParams;

  const timezoneParam = timezone || defaultTimezone;
  const timePresetParam = startTime ? CUSTOM_RANGE : timePreset;
  const startTimeParam = startTime ? momentTz.tz(startTime, timezoneParam) : undefined;
  const endTimeParam = endTime ? momentTz.tz(endTime, timezoneParam) : momentTz().tz(timezoneParam);
  const variantIdParam = variantId?.length ? variantId[0] : 'default';

  return (
    <UrlParamsContext.Provider
      value={{
        exportUrlCAFFOn,
        campaignId: parseInt(campaignId, 10),
        medium,
        startTimeParam,
        endTimeParam,
        timezoneParam,
        timePresetParam,
        overviewMetricsParam: overviewMetrics,
        timeSeriesMetricsParam: timeSeriesMetrics,
        segmentMetricsParam: segmentMetrics,
        segmentParam: { name: segment },
        regionParam: region,
        variantIdParam,
      }}
    >
      {children}
    </UrlParamsContext.Provider>
  );
};
